import ActionTypes from 'core/actions/actionTypes';


export function beginAjaxCall() {
	return { type: ActionTypes.AJAX_CALL_BEGIN };
}

export function ajaxCallError() {
	return { type: ActionTypes.AJAX_CALL_ERROR };
}



// WEBPACK FOOTER //
// ./src/core/actions/ajaxStatusActions.ts